export class ContractDetail {
	public id: number;
	public contractId: string;
	public supplierCommissionResponseReasonId: number;

	constructor(contractDetail?: ContractDetail) {
		Object.assign(this, contractDetail);
	}
}
